import React from 'react'
import './About.css';
import resume from '../../assets/files/Md-Saqib.pdf'
import  profileImg  from '../../assets/images/profile.webp'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faDownload} from '@fortawesome/free-solid-svg-icons'

const About = () => {
         
    return (
        <>
            <div className="sections">
                <div className="section-title"><span>01 .</span><h3>About Me</h3></div>
                <div className="about-main-sec">
                <div className="left-about-sec">
                    <p className="about-desc">
                        I'm a success-driven, determined Frontend developer. I have experience using HTML SCSS & JavaScript to build accessible component-based web pages and systems.
                        A passionate person willing to learn more technologies to become a better developer than i was yesterday. So determined and result orietend.
                    </p>
                    <p className="about-desc">
                        I have also achieved a good understanding of relational databases, as well as solid computer science foundations such as complex algorithms and code challenge type problem solving.
                    </p>
                    <a download href={resume} className="resume-btn">
                        <p className='resume-txt'>Download CV</p>
                        <FontAwesomeIcon className='downloadIcon' icon={faDownload} size='2x' bounce/>
                    </a>
                </div>
                <div className="right-about-sec">
                        <div className="right-about-img">
                            <img src={profileImg} alt="Mohammed Saqib" />
                        </div>
                            <div className="right-about-name" >
                                <span style={{'--i': '1'}}>M</span><span style={{'--i': '2'}}>o</span><span style={{'--i': '3'}}>h</span><span style={{'--i': '4'}}>a</span><span style={{'--i': '5'}}>m</span><span style={{'--i': '6'}}>m</span><span style={{'--i': '7'}}>e</span>
                                <span style={{'--i': '8'}}>d</span><span style={{'--i': '9'}}>&nbsp;</span><span style={{'--i': '10'}}>S</span><span style={{'--i': '11'}}>a</span><span style={{'--i': '12'}}>q</span><span style={{'--i': '13'}}>i</span><span style={{'--i': '14'}}>b</span>
                            </div>                            
                    </div>
                </div>
                <div id="skillSection"></div>
            </div>
        </>
    )
}

export default About;